import * as THREE from 'three'
import Sizes from '../Utils/Sizes.js'
import Time from '../Utils/Time.js'
import Camera from '../Camera.js'

import Renderer from '../Renderer.js'
import World from '../Location/World.js'
import Debug from '../Utils/Debug.js'

export default class LocationController {
    canvas = null
    stateController = null
    resources = null;

    constructor(canvas, stateController, resources) {
        // Options
        this.canvas = canvas
        this.stateController = stateController
        this.resources = resources

        // Setup
        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()

        // Scenes
        this.scenes = {
            'scene-1': new THREE.Scene(),
            //'scene-2': new THREE.Scene(),
        }
        this.scene = this.scenes['scene-1']

        this.camera = new Camera(this)
        this.world = new World(this)
        this.renderer = new Renderer(this)

        // Sizes resize event
        this.sizes.on('resize', () => {
            this.resize()
        })

        // Time tick event
        this.time.on('tick', () => {
            this.update()
        })
    }

    goToScene(sceneSlug) {
        this.scene = this.scenes[sceneSlug]

        // TODO: Here you can set the scene, camera and animations to their initial values

        //this.renderer.postProcessing()
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.camera.update()    
        this.world.update()
        this.renderer.update()
    }
}